module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    ref: "board",
    staticClass: "board",
    class: {
      'hover': _vm.hover
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": _vm.viewBox,
      "preserveAspectRatio": "xMidYMid meet"
    },
    on: {
      "mousemove": _vm.mouseMove,
      "mouseleave": _vm.mouseLeave,
      "!click": function($event) {
        _vm.click($event)
      }
    }
  }, [_c('grid', {
    attrs: {
      "size": _vm.size
    }
  }), _vm._v(" "), _c('g', _vm._l((_vm.stones), function(s) {
    return _c('stone', {
      key: "'' + s.x + s.y",
      attrs: {
        "x": _vm.pointToCoordinate(s.x),
        "y": _vm.pointToCoordinate(s.y),
        "color": s.color
      }
    })
  })), _vm._v(" "), (_vm.hover) ? _c('g', [_c('stone', {
    staticClass: "hover-stone",
    attrs: {
      "x": _vm.pointToCoordinate(_vm.hover.x),
      "y": _vm.pointToCoordinate(_vm.hover.y),
      "color": _vm.hover.color
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ko) ? _c('g', [_c('ko-marker', {
    attrs: {
      "x": _vm.pointToCoordinate(_vm.ko.x),
      "y": _vm.pointToCoordinate(_vm.ko.y)
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac1a4c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/game/Board.vue
// module id = 422
// module chunks = 1